"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Close = (0, _createIcon["default"])({
  path: 'M2.29541 2.29541C1.90488 2.68593 1.89891 3.32507 2.28944 3.71559L6.57388 8.00004L2.28944 12.2845C1.89891 12.675 1.90488 13.3141 2.29541 13.7047C2.68593 14.0952 3.32507 14.1012 3.71559 13.7106L8.00004 9.4262L12.2845 13.7106C12.675 14.1012 13.3141 14.0952 13.7047 13.7047C14.0952 13.3141 14.1012 12.675 13.7106 12.2845L9.4262 8.00004L13.7106 3.71559C14.1012 3.32507 14.0952 2.68593 13.7047 2.29541C13.3141 1.90488 12.675 1.89891 12.2845 2.28944L8.00004 6.57388L3.71559 2.28944C3.32507 1.89891 2.68593 1.90488 2.29541 2.29541Z',
  viewBox: '16 16',
  icon: 'close',
  displayName: 'Close'
});
var _default = exports["default"] = Close;